module.exports = __webpack_public_path__ + "img/img_product_warper_10.0f28792c.jpg";